<template>
  <main class="flex flex-row h-screen bg-white">
    <div class="flex flex-col w-full h-full">
        <div class="h-full">
          <!-- Componente que renderiza la página -->
          <child class="p-4-x" style="border-top:1px solid #adc2ea;" />
        </div>
    </div>
  </main>
</template>

<script>
import Navbar from '~/components/Navbar/Navbar'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import SegmentedProgressBar from '#/assets/js/components/pictograms/components/progress-summary/segmented-progress-bar.vue'
Vue.mixin({
  mounted() {
    let title = this.$options.title,
        subtitle = this.$options.subtitle,
        menuOption = this.$options.menuOption

    // De momento consideramos 'páginas' los componentes de Vue que tengan
    // una propiedad 'title' definida
    if (title !== undefined) {
      // Si el título es un array es que trae parámetros
      var _title = ''
      if (title instanceof Array) {
        var titleClone = title.slice(0)
        let key = titleClone.shift()
        _title = this.$t(key, titleClone)
      } else {
        _title = this.$t(title)
      }
      // Lo mismo para el subtítulo
      var _subtitle = ''
      if (subtitle instanceof Array) {
        var subtitleClone = subtitle.slice(0)
        let key = subtitleClone.shift()
        _subtitle = this.$t(key, subtitleClone)
      } else {
        _subtitle = this.$t(subtitle)
      }
      // Guardamos la info en el store
      let pageInfo = {
        title: _title,
        subtitle: _subtitle,
        menuOption: menuOption
      }
      this.$store.dispatch('app/updatePageInfo', { info: pageInfo })

      this.$options.metaInfo = (() => {
        return { title: pageInfo.title }
      })
    }
  },

  // GLOBAL METHODS
  methods: {
    asset(path) { // bucket de nuestros assets estaticos
      return process.env.MIX_ASSETS_URL + path;
    },
    assetVapor(path) { // bucket dinamico de vapor donde sube todo el raiz
      let base = window.config.assetUrl || '' // vapor o local?
      return base + '/' + path;
    },
    clientHost() {
      let currentUrl = window.location.host;
      let pieces = currentUrl.toLowerCase().split('.');
      return pieces[0];
    },
  }
})

export default {
  name: 'BlankContainer',
  components: {
    Navbar,
    SegmentedProgressBar,
  },

  data: () => ({
    version: window.config.version,
    showSidebar: false,
    windowWidth: null,
    isMovil: false,

    scrollNav: false, // no usado de momento
  }),

  computed: {
    ...mapGetters({
      pageInfo: 'app/pageInfo',
      mobile: 'device/mobile',
      company: 'app/company',
    }),
    titleCssClass() {
      return this.$route.name === 'issue.home' || this.$route.name === 'issue.home-sub' ?
        ' text-red-light ' :
        ' text-blue-light '
    }
  },

  created() {
    window.addEventListener('resize', this._CheckScreen)
    this._CheckScreen()
  },

  mounted() {
    window.addEventListener('scroll', this._UpdateScroll)
  },

  destroy() {
    window.removeEventListener('resize', this._CheckScreen)
  },

  methods: {
    _ToogleSidebar() {
      this.showSidebar = !this.showSidebar
    },

    _UpdateScroll() {
      const scrollPosition = window.scrollY
      if (scrollPosition > 50) {
        this.scrollNav = true
        return
      }
      this.scrollNav = false
    },

    async _CheckScreen() {
      this.windowWidth = window.innerWidth
      // if( this.windowWidth <= 640 ) {
      if (this.windowWidth <= 1024) {
        this.showSidebar = false
        this.isMobile = true
        await this.$store.dispatch("device/setMobile", { on_mobile: true });
        return
        // } else if (this.windowWidth <= 768) {
        // await this.$store.dispatch("responsive/setTablet", { isTablet: true });
        // return
      }

      this.showSidebar = true
      this.isMobile = false
      // await this.$store.dispatch("responsive/setTablet", { isTablet: false });
      await this.$store.dispatch("device/setMobile", { on_mobile: false });
    },

    _HandleShowSidebar(e) {
      if (this.mobile.on_mobile) this.showSidebar = e
    }
  }

};
</script>
